import {Base} from "./base";

class SystemService extends Base {
  constructor() {
    super();
  }

  /**
   * 健康宣教
   * @param {healthInfomationType} healthInfomationType [ENDOSCOPE_CENTER 内镜中心,HEALTH_CHECK_CENTER 体检中心,TUMOR_CENTER 肿瘤中心,INSPECTION_INSTRUCTION 检查须知]
   * @param healthInfomationServeId
   * @returns {Promise<[]>}
   */
  async jkxj(healthInfomationType, healthInfomationServeId) {
    const {list = [], code} = await this.$http('smarthos.endoscopy.health.Infomation.list.and.sublist', {
      healthInfomationType, healthInfomationServeId
    });
    return code === '0' ? list : [];
  }

  /**
   * 字典列表
   * @param dicName
   * @returns {Promise<[]>}
   */
  async dictionaryList(dicName) {
    const {code, list = []} = await this.$http('nethos.system.dictionary.list', {
      dicName
    });
    return code === '0' ? list : [];
  }

  /**
   * 资讯模块列表
   * @returns {Promise<void>}
   */
  async typeList() {
    const {code, list = []} = await this.$http('nethos.system.information.type.list', {});
    return code === '0' ? list : [];
  }

  /**
   * 资讯列表
   * @param typeId
   * @param typeName
   * @returns {Promise<[]>}
   */
  async newsList(typeId, typeName = '') {
    const {code, list = []} = await this.$http('nethos.system.information.list', {
      typeId,
      typeName
    });
    return code === '0' ? list : [];
  }

  /**
   * 系统资讯详情
   * @param typeName
   * @returns {Promise<void>}
   */
  async sysNewsDetail(typeName, title) {
    const {code, obj = {}} = await this.$http('nethos.system.information.sys.single', {
      typeName, title
    });
    return code === '0' ? obj : {};
  }

  /**
   * 资讯详情
   * @param newId
   * @returns {Promise<void>}
   */
  async newsDetail(newId) {
    const {obj = {}} = await this.$http('nethos.system.information.details', {
      newId
    })
    return obj
  }

  /**
   * 消息盒子
   * @param moduleType
   * @returns {Promise<void>}
   */
  async msgTypeList(moduleType) {
    const {code, list = []} = await this.$http('nethos.system.messagebox.moduletype.list', {
      moduleType
    });
    return code === '0' ? list : [];
  }

  /**
   * 更新大屏数据访问量
   * @param.dataVisitCountEnum[检验  INNER_SERVER_CHECKOUT   检查  INNER_SERVER_INSPECT   体检  INNER_SERVER_HEALTHCHECK   内镜  INNER_SERVER_IMAGE 数字影像 INNER_SERVER_QUERY_VIEW]
   * @returns {Promise<void>}
   */
  async datavisitcount(dataVisitCountEnum) {
    await this.$http('nethos.system.bigscreen.datavisitcount', {dataVisitCountEnum})
  }

  /**
   * 系统参数
   * @param key
   * @param defaultString
   * @returns {Promise<T.obj>}
   */
  async xtcs(key, defaultString) {
    const {code, obj} = await this.$http('nethos.system.param.string', {
      defaultString,
      key
    });
    return code === '0' ? obj : defaultString;
  }


  /**
   * 标准科室列表
   * @returns {Promise<void>}
   */
  async stddeptList() {
    const {list, code} = await this.$http('nethos.system.stddept.list', {});
    return code === '0' ? list : [];
  }

  /**
   * 查找科室
   * @param deptCode
   * @returns {Promise<void>}
   */
  async findStddept(deptCode) {
    const list = await this.stddeptList();
    let dept = {};
    const find = (list) => {
      for (let i = 0; i < list.length; i++) {
        const data = list[i];
        if (data.deptCode === deptCode) dept = data;
        else data.subDeptList && data.subDeptList.length && find(data.subDeptList);
      }
    }
    find(list);
    return dept;
  }

  /**
   *
   * @param options
   * @param options.gbDeptCode
   * @param options.pageSize
   * @param options.pageNum
   * @param options.renewalOpenStatus
   * @returns {Promise<*>}
   */
  async docList(options, needPaginator = false) {
    const {code, list = [], paginator = {}} = await this.$http('nethos.doc.list', options);
    if (needPaginator) return {list, paginator};
    return code === '0' ? list : []
  }

  /**
   *
   * @param options
   * @param options.bookDeptId
   * @param options.pageNum
   * @param options.pageSize
   * @returns {Promise<void>}
   */
  async docListByDeptId(options) {
    return await this.$http('nethos.doc.book.dept.list', options);
  }


  /**
   * 首页搜索
   * @param options
   * @returns {Promise<*[]>}
   */
  async searchIndex(options, needPaginator = false) {
    const {list = [], paginator = {}} = await this.$http('nethos.system.search.index', options)
    return needPaginator ? {list, paginator} : list;
  }

  /**
   * 意见反馈
   * @param content
   * @param contact
   * @param contact_way
   * @returns {Promise<void>}
   */
  async feedback({content, contact, contact_way}) {
    const {code} = await this.$http('nethos.system.feedback.add', {
      content,
      concat: contact,
      concatWay: contact_way
    });
    return code === '0';
  }

  async upload({base64, originalName}) {
    const {code, obj = {}} = await this.$http('nethos.system.atta.upload.image.base64', {
      base64, originalName
    });
    return code === '0' ? obj : {};
  }

  /**
   * 验证码验证
   * @param captcha
   * @param cid
   * @returns {Promise<boolean>}
   */
  async captchaCheckV2({captcha, cid}) {
    const {code} = await this.$http('nethos.system.captcha.checkcaptcha.v2', {
      captcha, cid
    });
    return code === '0';
  }

  /**
   * 获取隐私协议阅读状态
   * @param moduleType 模块类型：SYS-系统 CONSULT_INFO-咨询
   * @returns {Promise<void>}
   */
  async ysxyGet(moduleType) {
    const {obj} = await this.$http('smarthos.privacy.protocol.status.get', {moduleType}, {}, {
      showError: false,
      noloading: false
    });
    return obj;
  }

  /**
   * 设置隐私协议阅读状态
   * @param moduleType
   * @returns {Promise<void>}
   */
  async ysxySet(moduleType) {
    await this.$http('smarthos.privacy.protocol.records.save', {
      moduleType
    }, {}, {noloading: false});
  }

  /**
   * 根据appid获得配置
   * @param appid
   * @returns {Promise<{msg: T.msg, obj: {channel,appid}}>}
   */
  async appidDetails(appid) {
    const {obj = {}, msg} = await this.$http('nethos.system.channel.hos.appid.details', {
      appid
    })
    return {obj, msg}
  }

  /**
   *
   * @param channel
   * @returns {Promise<{}>}
   */
  async channelDetails(channel) {
    const {obj = {}} = await this.$http('nethos.system.channel.hos.channel.details', {channel});
    return obj;
  }


  /**
   * 消息盒子-模块消息
   * @param options
   * @param options.moduleType
   * @returns {Promise<[]>}
   */
  async messageboxModuletypeList(options) {
    const {list = []} = await this.$http('nethos.system.messagebox.moduletype.list', options)
    return list
  }

  /**
   * 消息盒子详情
   * @param messageId
   * @returns {Promise<{}>}
   */
  async messageboxDetails(messageId) {
    const {obj = {}} = await this.$http('nethos.system.messagebox.details', {
      messageId
    })
    return obj;
  }

  /**
   * 未读数
   * @param moduleType
   * @param messageType
   * @returns {Promise<number>}
   */
  async messageboxModuleCount({moduleType, messageType}) {
    const {obj = 0} = await this.$http('nethos.system.messagebox.module.count', {
      moduleType, messageType
    });
    return obj;
  }

  /**
   * 消息盒子设置已读
   * @param messageId
   * @returns {Promise<string>}
   */
  async messageboxRead(messageId) {
    const {code = ''} = await this.$http('nethos.system.messagebox.read', {messageId})
    return code
  }

  /**
   * 国标科室
   * @returns {Promise<void>}
   */
  async gbdeptList() {
    const {list = []} = await this.$http('nethos.system.gbdept.list', {})
    return list;
  }

  /**
   * 首页
   * @returns {Promise<void>}
   */
  async appPatIndex() {
    const {obj = {}} = await this.$http('nethos.system.app.pat.index', {})
    return obj;
  }


  /**
   * 推送免打扰设置列表
   * @param moduleType
   * @returns {Promise<*[]>}
   */
  async pushServeSettingsList(moduleType) {
    const {list = []} = await this.$http('smarthos.system.push.serve.settings.list', {
      moduleType
    });
    return list
  }


  /**
   * 推送免打扰设置
   * @param pushStatus
   * @param moduleType
   * @returns {Promise<string>}
   */
  async pushServeSettings({pushStatus, moduleType}) {
    const {code = '0'} = await this.$http('smarthos.system.push.serve.settings', {
      moduleType, pushStatus
    });
    return code
  }

  /**
   *
   * @param options
   * @param options.moduleCode DAY_SURGERY
   * @param options.statusCode
   * @param options.ssxhId
   * @param options.areaCode A||B
   * @param options.courtyardId
   * @returns {Promise<[]>}
   */
  async processDetailList(options) {
    const {list = []} = await this.$http('smarthos.system.process.detail.list', options, {}, {noloading: true})
    return list
  }

  /**
   *
   * @param option
   * @param option.statusCode
   * @param option.moduleCode WAITING_HOSPITAL
   * @param option.courtyardName
   * @param option.areaCode A
   * @returns {Promise<[]>}
   */
  async admissionList(option) {
    const {list = []} = await this.$http('smarthos.system.admission.list', option);
    return list;
  }

  /**
   *
   * @param options
   * @param options.processId
   * @param options.ssxhId
   * @returns {Promise<void>}
   */
  async processRead(options) {
    await this.$http('smarthos.system.process.read', {
      ...options
    }, {}, {noloading: true})
  }

  /**
   *
   * @param options
   * @param options.attaModelType
   * @param options.originalName
   * @param options.fileType
   * @returns {Promise<{}>}
   */
  async attaQiniuToken(options) {
    const {obj = {}} = await this.$http('nethos.system.atta.qiniu.token', options);
    return obj;
  }


  /**
   * 验证码-生成年度报告
   * @param mobile
   * @returns {Promise<{}>}
   */
  async docReportCaptcha(mobile) {
    const {obj = {}} = await this.$http('nethos.system.doc.report.captcha', {mobile});
    return obj;
  }

  async resetPwdCaptcha(mobile) {
    const {obj = {}} = await this.$http('nethos.system.captcha.pat.password.reset', {mobile});
    return obj;
  }

  /**
   * 患者登录验证码
   * @param mobile
   * @returns {Promise<{}>}
   */
  async patLoginCaptcha(mobile) {
    const {obj = {}} = await this.$http('nethos.system.captcha.pat.login', {mobile});
    return obj;
  }

  //

  async txReport(txRegisteredCallback) {
    await this.$http('smarthos.registrationguidance.book.return.url', {
      txRegisteredCallback
    })
  }

  /**
   *
   * @returns {Promise<*[]>}
   */
  async areaList() {
    const {list = []} = await this.$http('nethos.system.area.list', {});
    return list;
  }

  /**
   * 根据typeName获取系统资讯
   * @param typeName
   * @returns {Promise<{}>}
   */
  async sysInfoByTypeName(typeName) {
    const {obj = {}} = await this.$http('nethos.system.information.sys.single', {
      typeName
    });
    return obj;
  }

  /**
   * 发送验证码
   * @description 新用户注册，身份证已被占用，修改为当前手机号
   * @param options.checkToken
   * @param options.mobile
   * @returns {Promise<T>}
   */
  async sendCaptchaByIdCard(options) {
    return await this.$http('nethos.system.captcha.pat.mobile.modify', options);
  }

  /**
   * 发送验证码-添加就诊人
   * @param options.mobile
   * @returns {Promise<T>}
   */
  async sendCaptchaInAddCompat(options) {
    return await this.$http('nethos.system.captcha.commpat.add', options);
  }

  /**
   * 发送验证码-添加就诊人
   * @param options.mobile
   * @returns {Promise<T>}
   */
  async sendCaptchaInAddCompatV2(options) {
    return await this.$http('nethos.system.captcha.commpat.add.v2', options);
  }

  /**
   * 发送验证码
   * @description 修改就诊人
   * @param options.commpatId
   * @param options.mobile
   * @returns {Promise<T>}
   */
  async sendCaptchaInModifyCompat(options) {
    return await this.$http('nethos.system.captcha.commpat.mobile.modify', options);
  }

  /**
   * 验证码验证
   * @param cid
   * @param captcha
   * @returns {Promise<boolean>}
   **/
  async checkCaptchaV2(cid, captcha) {
    return await this.$http('nethos.system.captcha.checkcaptcha.v2', {cid, captcha});
  }

  /**
   * 埋点上报
   * @param options.moduleType
   * @param options.remark
   * @returns {Promise<void>}
   */
  async dataVisitCountRecord(options) {
    await this.$http('smarthos.system.data.visit.count.record', options);
  }

}

export const systemService = new SystemService();



// WEBPACK FOOTER //
// ./src/services/system.js